module.exports = __webpack_public_path__ + "assets/img/13_332.b2df9a2e.jpg";